import { Checkbox, ListItemText } from '@mui/material';

type FilterMenuProps = {
  option: string;
  isChecked: boolean;
};

export const FilterMenuItem = ({ option, isChecked }: FilterMenuProps) => {
  return (
    <>
      <Checkbox checked={isChecked} color="success" />
      <ListItemText primary={option} sx={{ color: '#6F7174' }} />
    </>
  );
};
